import { render, staticRenderFns } from "./ChatListSkeleton.vue?vue&type=template&id=31834b76&scoped=true"
import script from "./ChatListSkeleton.vue?vue&type=script&lang=js"
export * from "./ChatListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChatListSkeleton.vue?vue&type=style&index=0&id=31834b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31834b76",
  null
  
)

export default component.exports